import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["original", "translated", "button"];
  static values = { 
    showOriginal: { type: Boolean, default: false }
  };

  connect() {
    // Initially hide original content if we're showing translated
    if (!this.showOriginalValue) {
      this.originalTargets.forEach(el => el.classList.add('d-none'));
    }
  }

  toggle() {
    this.showOriginalValue = !this.showOriginalValue;
    
    if (this.showOriginalValue) {
      // Show original, hide translated
      this.originalTargets.forEach(el => el.classList.remove('d-none'));
      this.translatedTargets.forEach(el => el.classList.add('d-none'));
      this.buttonTarget.textContent = this.buttonTarget.dataset.translatedText;
    } else {
      // Show translated, hide original
      this.originalTargets.forEach(el => el.classList.add('d-none'));
      this.translatedTargets.forEach(el => el.classList.remove('d-none'));
      this.buttonTarget.textContent = this.buttonTarget.dataset.originalText;
    }
  }
}
